export enum SocialAuthPageName {
    GOOGLE = 'Google',
    FACEBOOK = 'Facebook',
    APPLE = 'Apple'
}

export const PAGE_NAME = {
    SIGN_UP: 'SignUp',
    SIGN_IN: 'SignIn',
    FORGOT_PASSWORD: 'ForgotPassword',
    EMAIL_OTP_SIGN_IN: 'emailOTP-signIn',
    EMAIL_OTP_SIGN_UP: 'emailOTP-signUp',
    GOOGLE: SocialAuthPageName.GOOGLE,
    FACEBOOK: SocialAuthPageName.FACEBOOK,
    APPLE: SocialAuthPageName.APPLE
};


export const PAGE_NAME_CONSTANT = ['SignUp','SignIn','ForgotPassword','emailOTP-signIn','emailOTP-signUp', SocialAuthPageName.GOOGLE, SocialAuthPageName.FACEBOOK, SocialAuthPageName.APPLE]

export const SCREEN_SIZE = {
    EXTRA_SMALL_SCREEN: 'extraSmallScreen',
    SMALL_SCREEN: 'smallScreen',
    MEDIUM_SCREEN: 'mediumScreen',
    LARGE_SCREEN: 'largeScreen',
    EXTRA_LARGE_SCREEN: 'extraLargeScreen'
}

export const ERROR_CODE = {
    NULL_ERROR: 'NULL_ERROR',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    BRUTE_FORCE_PROTECTION: 'BRUTE_FORCE_PROTECTION',
    GENERIC_ERROR: 'GENERIC_ERROR',
    SOCIAL_SIGNIN_ERROR: 'SOCIAL_SIGNIN_ERROR',
    EMAIL_UNVERIFIED: 'EMAIL_UNVERIFIED',
    ACCESS_DENIED: 'ACCESS_DENIED',
    USER_EXISTS: 'USER_EXISTS',
    MAX_ATTEMPT_ERROR: 'MAX_ATTEMPT_ERROR',
    PASSWORD_HISTORY_ERROR: 'PASSWORD_HISTORY_ERROR',
    MAXIMUM_ATTEMPTS_REACHED: 'MAXIMUM_ATTEMPTS_REACHED',
    OTP_MAX_ATTEMPT_ERROR: 'OTP_MAX_ATTEMPT_ERROR',
    SOCIAL_SIGN_IN_FAILURE: 'SOCIAL_SIGN_IN_FAILURE',
    EMAIL_VERIFIED:'EMAIL_VERIFIED',
    REAUTHENTICATION_REQUIRED:'REAUTHENTICATION_REQUIRED',
    POST_CHECKOUT_GUEST_USER_SIGNUP: 'POST_CHECKOUT_GUEST_USER_SIGNUP',
    MISSING_EMAIL: 'MISSING_EMAIL',
    INVALID_EMAIL_ADDRESS: 'INVALID_EMAIL_ADDRESS',
    EMAIL_NOT_PRESENT: 'EMAIL_NOT_PRESENT'
}

export const  LOCALE_MAPPING= {
    'en-IE': 'ie',
    'en-CA': 'ca',
    'pt-PT': 'pt',
    'es-ES': 'es',
    'nl-BE': 'be-nl',
    'fr-BE': 'be-fr',
    'de-CH': 'ch-de',
    'fr-CH': 'ch-fr',
    'it-CH': 'ch-it',
    'en-GB': 'uk',
    'de-DE': 'de',
    'fr-FR': 'fr',
    'it-IT': 'it',
    'nl-NL': 'nl',
    'de-AT': 'at',
    'sv-SE': 'se',
    'nn-NO': 'no',
    'fi-FI': 'fi',
    'da-DK': 'dk',
    'cs-CZ': 'cz',
    'sk-SK': 'sk',
    'hu-HU': 'hu',
    'en-US': 'us',
    'ja-JP': '',
    'en-NZ': 'nz',
    'en-AU': 'au',
}

export const TERMS_OF_USE_PAGE_MAPPING = {
    'us': 's/terms-of-use',
    'uk': 's/terms-of-use',
    'ca': 's/terms-of-use',
    'ie': 's/terms-of-use',
    'au': 's/terms-of-use',
    'nz': 's/terms-of-use',
    'de': 's/nutzungsbedingungen',
    'at': 's/nutzungsbedingungen',
    'ch-de': 's/nutzungsbedingungen',
    'fr': 's/conditions-dutilisation',
    'be-fr': 's/conditions-dutilisation',
    'ch-fr': 's/conditions-dutilisation',
    'it': 's/termini-di-utilizzo',
    'ch-it': 's/termini-di-utilizzo',
    'nl': 's/gebruiksvoorwaarden',
    'be-nl': 's/gebruiksvoorwaarden',
    'es': 's/condiciones-de-uso',
    'fi': 's/käyttöehdot',
    'dk': 's/brugsvilkår',
    'cz': 's/podminky-pouziti',
    'hu': 's/hasznalat-feltetelei',
    'no': 's/vilkår-for-bruk',
    'pt': 's/condições-de-utilização',
    'sk': 's/podmienky-pouzivania-stranky',
    'se': 's/användarvillkor'
};

export const FALLBACK_LOCALE = 'en-US'

export const COOKIE_CONSTANT = {
    CURRENT_PAGE_COOKIE_KEY: 'lock_widget_current_page',
    LOCALE_COOKIE_KEY: 'reset_password_locale'
}

export const SUCCESS_MESSAGES = ['RESET_PASSWORD_SUCCESSFUL', 'UPDATE_PASSWORD', 'EMAIL_VERIFIED']
export const EXCLUDES_MESSAGES = ['USER_NOT_LOGGEDIN', 'invalid_request','INVALID_SESSION']
